import { motion } from 'framer-motion';
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'constants/animation-properties';

import Background from 'assets/Home/portfolio/dashboard2.avif'
import Laptop from 'assets/Home/portfolio/dashboard3.avif'
import Img1 from 'assets/Home/portfolio/fornatures1.avif'

const Fornatures = ({ data }: any) => {

    return (
        <>
            <div
                id='change'
                style={{
                    backgroundImage: `url(${Background})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    height: '100vh',
                }}
                className="flex justify-center items-center mb-24 w-full">
                <motion.img
                    src={Laptop}
                    alt="Laptop"
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                </motion.img>
            </div>
            <section className='pb-24 container'>
                <motion.h4
                    className='mb-6 font-semibold text-32 text-black tablet:text-xl'
                    transition={{ delay: 0.2 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    Management System
                </motion.h4>

                <motion.img
                    src={Img1}
                    alt="Img1"
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                </motion.img>
            </section>
        </>
    )
}

export default Fornatures
